module.exports = __webpack_public_path__ + "@/assets/img/footer-onmex.031ab817.png";